import { Route } from "react-router-dom";
import { privateRoutes, publicRoutes } from "./Menus.consts";
import ProtectedRoute from "../ProtectedRoute";

export function generatePublicRoutes() {
  return Object.entries(publicRoutes).map(([key, route]) => {
    const Element = route.element;

    return (
      <Route
        key={key}
        path={route.path}
        element={typeof Element === "function" ? <Element /> : Element}
      />
    );
  });
}

export function generatePrivateRoutes() {
  return Object.entries(privateRoutes).map(([key, route]) => {
    const Element = route.element;

    return (
      <Route
        key={key}
        path={route.path}
        element={
          <ProtectedRoute
            authorizedRoles={route.authorizedRoles}
            component={typeof Element === "function" ? <Element /> : Element}
          />
        }
      />
    );
  });
}
